import { Link } from 'react-router-dom';
import { Building2, Mail, Phone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Building2 className="h-8 w-8" style={{ color: 'var(--primary-500)' }} />
              <div>
                <div className="text-lg font-semibold" style={{ color: 'var(--primary-700)' }}>
                  RetailInvest
                </div>
                <div className="text-xs" style={{ color: 'var(--secondary-500)' }}>
                  by Heinrichs Immobilien
                </div>
              </div>
            </div>
            <p className="text-sm mb-4" style={{ color: 'var(--secondary-600)' }}>
              Heinrichs Immobilien – Ihr spezialisierter Makler für Handelsimmobilien in Deutschland.
              Von Supermarkt bis Fachmarktzentrum begleiten wir Sie beim erfolgreichen Verkauf.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-sm" style={{ color: 'var(--secondary-600)' }}>
                <Mail className="h-4 w-4 mr-2" />
                <a href="mailto:info@retail-invest.com" className="hover:underline">
                  info@retail-invest.com
                </a>
              </div>
              <div className="flex items-center text-sm" style={{ color: 'var(--secondary-600)' }}>
                <Phone className="h-4 w-4 mr-2" />
                <a href="tel:+4981611851360" className="hover:underline">08161 1851360</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--primary-700)' }}>
              Schnellzugriff
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/fuer-eigentuemer" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Für Eigentümer
                </Link>
              </li>
              <li>
                <Link to="/fuer-investoren" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Für Investoren
                </Link>
              </li>
              <li>
                <Link to="/tools" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Tools
                </Link>
              </li>
              <li>
                <Link to="/ablauf" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Verkaufsprozess
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Über uns
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--primary-700)' }}>
              Rechtliches
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/impressum" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm hover:underline" style={{ color: 'var(--secondary-600)' }}>
                  Cookie-Richtlinie
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="text-center">
            <div className="mb-4">
              <h4 className="text-sm font-semibold mb-3" style={{ color: 'var(--primary-700)' }}>
                Weitere Angebote von Heinrichs Immobilien
              </h4>
              <div className="flex flex-wrap justify-center gap-6">
                <a
                  href="https://www.heinrichsimmobilien.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-[#D4A853] transition-colors font-medium"
                  style={{ color: 'var(--secondary-600)' }}
                >
                  Heinrichs Immobilien →
                </a>
                <a
                  href="https://www.agrarkapital.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-[#D4A853] transition-colors font-medium"
                  style={{ color: 'var(--secondary-600)' }}
                >
                  AgrarKapital →
                </a>
                <a
                  href="https://www.preisatlas-freising.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-[#D4A853] transition-colors font-medium"
                  style={{ color: 'var(--secondary-600)' }}
                >
                  Preisatlas Freising →
                </a>
              </div>
            </div>
            <p className="text-sm mb-2" style={{ color: 'var(--secondary-500)' }}>
              © {new Date().getFullYear()} RetailInvest by Heinrichs Immobilien. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;